// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"style_containerBox__1BYze","slide":"style_slide__oYfR1"};